import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from '../../../../Common/FormatFunctions/FormatAmount';
import { RingLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableFooter } from "@mui/material";
import PdfPreview from '../../../../Common/PdfPreview_Default';

const apikey = process.env.REACT_APP_API;

const AwakCustomerReport = () => {
    const location = useLocation();
    const Company_Name = sessionStorage.getItem('Company_Name')
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const company_Code = searchParams.get('Company_Code');
    const Year_Code = searchParams.get('Year_Code');
    const oldCustomerCode = searchParams.get('Customer_Code');
    const [pdfPreview, setPdfPreview] = useState(null);

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [grandTotals, setGrandTotals] = useState({
        Awak_Qty: 0,
        ReadyQty: 0,
        RejectedQty: 0,
        oldsalerate: 0,
    });

    const API_URL = `${apikey}/CustomerFarmerReport`;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        Company_Code: company_Code,
                        Year_Code: Year_Code,
                        oldCustomerCode: oldCustomerCode
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [API_URL]);

    // useEffect(() => {
    //     if (finalReportData.length > 0) {
    //         const totals = finalReportData.reduce(
    //             (acc, item) => {
    //                 const qty = Number(item.Awak_Qty) || 0;
    //                 const SaleRate = Number(item.oldsalerate) || 0;

    //                 // Total Awak Qty
    //                 acc.Awak_Qty += qty;
    //                 acc.oldsalerate += SaleRate;

    //                 // Ready for sale qty (ONLY when Readyforsale === 'Y')
    //                 if (item.Readyforsale === "Y") {
    //                     acc.ReadyQty += qty;
    //                 }

    //                 if (
    //                     item.Readyforsale === "N" &&
    //                     item.RejectDate &&
    //                     item.AuctionMark === "N" &&
    //                     item.sold === "N" &&
    //                     Number(item.salebilldocno) === 0
    //                 ) {
    //                     acc.RejectedQty += qty;
    //                 }


    //                 return acc;
    //             },
    //             {
    //                 Awak_Qty: 0,
    //                 ReadyQty: 0,
    //                 RejectedQty: 0,
    //                 oldsalerate: 0,
    //             }
    //         );

    //         setGrandTotals(prev => ({
    //             ...prev,
    //             Awak_Qty: totals.Awak_Qty,
    //             ReadyQty: totals.ReadyQty,
    //             RejectedQty: totals.RejectedQty,
    //             oldsalerate: totals.oldsalerate,
    //         }));
    //     }
    // }, [reportData]);

    useEffect(() => {
        if (finalReportData.length > 0) {
            const totals = finalReportData.reduce(
                (acc, item) => {
                    const qty = Number(item.Awak_Qty) || 0;
                    const SaleRate = Number(item.oldsalerate) || 0;

                    // Total Awak Qty
                    acc.Awak_Qty += qty;
                    acc.oldsalerate += SaleRate;

                    // Ready for sale qty & count
                    if (item.Readyforsale === "Y") {
                        acc.ReadyQty += qty;      // sum of qty
                        acc.ReadyCount += 1;      // count of items
                    }

                    // Rejected qty & count
                    if (
                        item.Readyforsale === "N" &&
                        item.RejectDate &&
                        item.AuctionMark === "N" &&
                        item.sold === "N" &&
                        Number(item.salebilldocno) === 0
                    ) {
                        acc.RejectedQty += qty;   // sum of qty
                        acc.RejectedCount += 1;   // count of items
                    }

                    return acc;
                },
                {
                    Awak_Qty: 0,
                    ReadyQty: 0,
                    RejectedQty: 0,
                    oldsalerate: 0,
                    ReadyCount: 0,      // add this
                    RejectedCount: 0,   // add this
                }
            );

            setGrandTotals(prev => ({
                ...prev,
                Awak_Qty: totals.Awak_Qty,
                ReadyQty: totals.ReadyQty,
                RejectedQty: totals.RejectedQty,
                oldsalerate: totals.oldsalerate,
                ReadyCount: totals.ReadyCount,
                RejectedCount: totals.RejectedCount,
            }));
        }
    }, [reportData]);

    // const handleExportToExcel = () => {
    //     const wb = XLSX.utils.book_new();
    //     const headers = [
    //         "Awak No", "Date", "Customer Code", "Customer Name", "Quantity", "Item Name", "Godown Name", "Line Name", "Ready For Sale",
    //     ];

    //     const formattedData = reportData.map(item => ({
    //         "Awak No": item.Doc_No,
    //         "Date": item.Doc_Date,
    //         "Customer Code": item.Customer_Code,
    //         "Customer Name": item.CustomerName,
    //         "Quantity": Number(item.Awak_Qty) || 0,
    //         "Item Name": item.ItemName,
    //         "Godown Name": item.System_Name_E,
    //         "Line Name": item.LineName,
    //         "Ready For Sale": item.Readyforsale,

    //     }));
    //     const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    //     const wsCols = [
    //         { wch: 12, alignment: { horizontal: "left" } },    // Awak No
    //         { wch: 15, alignment: { horizontal: "center" } },  // Date
    //         { wch: 12, alignment: { horizontal: "center" } },  // Farmer Code
    //         { wch: 25, alignment: { horizontal: "right" } },    // Farmer Name
    //         { wch: 25, alignment: { horizontal: "left" } },    // Item Name
    //         { wch: 25, alignment: { horizontal: "left" } },    // Godown Name
    //         { wch: 25, alignment: { horizontal: "left" } },    // Line Name
    //         { wch: 12, alignment: { horizontal: "right" } },   // Quantity
    //         { wch: 12, alignment: { horizontal: "right" } },   // Despatched
    //         { wch: 12, alignment: { horizontal: "right" } },   // Balance
    //         { wch: 15, alignment: { horizontal: "left" } },    // Auction Mark
    //     ];


    //     ws["!cols"] = wsCols;
    //     XLSX.utils.book_append_sheet(wb, ws, 'CustomerReport');
    //     XLSX.writeFile(wb, 'CustomerReport.xlsx');
    // };

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();

        const headers = [
            "Awak No",
            "Item Name",
            "Quantity",
            "Sale Rate",
            "Ready For Sale",
            "Godown Name",
            "Line Name"
        ];

        const formattedData = [];

        const groupedData = {};

        finalReportData.forEach(item => {
            const key = [
                Company_Name,
                item.OLDCustomerName || "",
                item.customermobile || ""
            ].join("|");

            if (!groupedData[key]) {
                groupedData[key] = {
                    companyName: Company_Name,
                    customerName: item.OLDCustomerName || "",
                    mobile: item.customermobile || "",
                    saudadate: item.SaudaDate || "",
                    items: []
                };
            }

            groupedData[key].items.push(item);
        });

        let grandTotalQty = 0;
        let grandReadyQty = 0;
        let grandRejectedQty = 0;

        const getReadyStatus = (value) => {
            if (value === "Y") return "Confirm";
            if (value === "N") return "Rejected";
            return "";
        };

        Object.values(groupedData).forEach(group => {

            // ===== Customer Info (STARTING FROM COLUMN A) =====

            formattedData.push({
                "Item Name": "Company Name:",
                "Quantity": group.companyName
            });

            formattedData.push({
                "Item Name": "Customer Name:",
                "Quantity": group.customerName
            });

            formattedData.push({
                "Item Name": "Mobile No:",
                "Quantity": group.mobile
            });

            formattedData.push({
                "Item Name": "Sauda Date:",
                "Quantity": formatDate(group.saudadate)
            });

            formattedData.push({}); // blank row

            // ===== Table Header Row =====
            formattedData.push(
                headers.reduce((obj, h) => {
                    obj[h] = h;
                    return obj;
                }, {})
            );

            let totalQty = 0;
            let readyQty = 0;
            let rejectedQty = 0;
            const itemWiseQty = {};

            group.items.forEach(item => {

                const qty = Number(item.Awak_Qty) || 0;
                const itemName = item.ItemName || "";

                totalQty += qty;
                grandTotalQty += qty;

                if (item.Readyforsale === "Y") {
                    readyQty += qty;
                    grandReadyQty += qty;
                }

                if (item.Readyforsale === "N") {
                    rejectedQty += qty;
                    grandRejectedQty += qty;
                }

                if (!itemWiseQty[itemName]) {
                    itemWiseQty[itemName] = 0;
                }
                itemWiseQty[itemName] += qty;

                formattedData.push({
                    "Awak No": item.Doc_No,
                    "Item Name": itemName,
                    "Quantity": qty,
                    "Sale Rate": Number(item.oldsalerate) || 0,
                    "Ready For Sale": getReadyStatus(item.Readyforsale),
                    "Godown Name": item.System_Name_E,
                    "Line Name": item.LineName,
                });
            });

            // ===== Group Totals =====
            formattedData.push({});

            formattedData.push({
                "Item Name": `Quantity Total : ${totalQty}`,
                "Quantity": `Ready For Sale Qty : ${readyQty}`,
                "Sale Rate": `Rejected Qty : ${rejectedQty}`
            });


            const itemWiseTotalLine = Object.keys(itemWiseQty)
                .map(itemName => `${itemName} : ${itemWiseQty[itemName]}`)
                .join("    ");

            formattedData.push({
                "Item Name": itemWiseTotalLine
            });

            formattedData.push({});
        });

        // ===== Grand Total =====
        formattedData.push({
            "Awak No": `Total Quantity : ${grandTotalQty}`,
            "Item Name": `Ready For Sale Qty : ${grandReadyQty}`,
            "Quantity": `Rejected Qty : ${grandRejectedQty}`
        });

        // ===== Create Sheet (IMPORTANT CHANGE) =====
        const ws = XLSX.utils.json_to_sheet(formattedData, {
            header: headers,
            skipHeader: true
        });

        ws["!cols"] = [
            { wch: 12 },
            { wch: 18 },
            { wch: 12 },
            { wch: 12 },
            { wch: 18 },
            { wch: 15 }
        ];

        XLSX.utils.book_append_sheet(wb, ws, "CustomerReport");
        XLSX.writeFile(wb, "CustomerReport.xlsx");
    };




    // const handleExportToExcel = () => {
    //     const wb = XLSX.utils.book_new();
    //     const headers = [
    //         "Awak No", "Date", "Customer Code", "Customer Name", "Quantity", "Item Name", "Godown Name", "Line Name", "Sale Rate", "Ready For Sale",
    //     ];

    //     const groupedData = reportData.reduce((acc, item) => {
    //         if (!acc[item.Ac_code]) acc[item.Ac_code] = [];
    //         acc[item.Ac_code].push(item);
    //         return acc;
    //     }, {});

    //     const formattedData = [];
    //     let isFirstFarmer = true;

    //     Object.keys(groupedData).forEach(farmerCode => {
    //         const farmerRows = groupedData[farmerCode];
    //         const Customername = farmerRows[0].CustomerName;

    //         // Insert headers only for subsequent farmers
    //         if (!isFirstFarmer) {
    //             formattedData.push({
    //                 "Awak No": "Awak No",
    //                 "Date": "Date",
    //                 "Customer Code": "Customer Code",
    //                 "Customer Name": "Customer Name",
    //                 "Quantity": "Quantity",
    //                 "Item Name": "Item Name",
    //                 "Godown Name": "Godown Name",
    //                 "Line Name": "Line Name",
    //                 "Sale Rate": "Sale Rate",
    //                 "Ready For Sale": "Ready For Sale",
    //             });
    //         }

    //         // Insert data rows
    //         farmerRows.forEach((item, index) => {
    //             formattedData.push({
    //                 "Awak No": item.Doc_No,
    //                 "Date": item.Doc_Date,
    //                 "Customer Code": item.Ac_code,
    //                 "Customer Name": index === 0 ? Customername : "", // show only once
    //                 "Quantity": Number(item.Awak_Qty) || 0,
    //                 "Item Name": item.ItemName,
    //                 "Godown Name": item.System_Name_E,
    //                 "Line Name": item.LineName,
    //                 "Sale Rate": item.oldsalerate,
    //                 "Ready For Sale": item.Readyforsale,
    //             });
    //         });

    //         // Subtotal row
    //         const totalQty = farmerRows.reduce((sum, i) => sum + (Number(i.Awak_Qty) || 0), 0);
    //         formattedData.push({
    //             "Awak No": "",
    //             "Date": "",
    //             "Customer Code": "",
    //             "Customer Name": "Total",
    //             "Quantity": totalQty,
    //             "Item Name": "",
    //             "Godown Name": "",
    //             "Line Name": "",
    //             "Sale Rate": "",
    //             "Ready For Sale": "",
    //         });

    //         // Empty row for spacing
    //         formattedData.push({
    //             "Awak No": "",
    //             "Date": "",
    //             "Customer Code": "",
    //             "Customer Name": "",
    //             "Quantity": "",
    //             "Item Name": "",
    //             "Godown Name": "",
    //             "Line Name": "",
    //             "Sale Rate": "",
    //             "Ready For Sale": "",
    //         });

    //         isFirstFarmer = false;
    //     });

    //     const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    //     // Set column widths
    //     ws["!cols"] = [
    //         { wch: 12 }, { wch: 15 }, { wch: 12 }, { wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 12 },
    //     ];

    //     // Bold Farmer Name, headers, and Total row
    //     Object.keys(ws).forEach(cell => {
    //         if (cell.startsWith("!")) return;
    //         const value = ws[cell].v;
    //         if (
    //             (typeof value === "string" && value === "Customer Name") ||
    //             (typeof value === "string" && value === "Total") ||
    //             headers.includes(value)
    //         ) {
    //             ws[cell].s = { font: { bold: true } };
    //         }
    //     });

    //     XLSX.utils.book_append_sheet(wb, ws, "CustomerReport");
    //     XLSX.writeFile(wb, "CustomerReport.xlsx");
    // };


    const handlePrint = () => {
        const companyName = Company_Name;
        const fromDateParam = searchParams.get('fromDate');
        const toDateParam = searchParams.get('toDate');

        const doc = generatePDFDocument(companyName,);
        const pdfUrl = URL.createObjectURL(doc);
        const printWindow = window.open(pdfUrl);
        printWindow.onload = function () {
            setTimeout(() => {
                printWindow.print();
            }, 500);
        };
    };



    const generatePDFDocument = (companyName) => {
        const doc = new jsPDF();

        // ===== Header =====
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(companyName, doc.internal.pageSize.width / 2, 15, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`GSTN : ${Company_GSTNO}`, doc.internal.pageSize.width / 2, 23, { align: 'center' });

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text("Customer Report Print", doc.internal.pageSize.width / 2, 32, { align: 'center' });

        let currentY = 45;

        // ===== Group data =====
        const groupedData = {};

        finalReportData.forEach(item => {
            const key = [
                Company_Name,
                item.OLDCustomerName || "",
                item.customermobile || ""
            ].join("|");

            if (!groupedData[key]) {
                groupedData[key] = {
                    companyName: Company_Name,
                    customerName: item.OLDCustomerName || "",
                    mobile: item.customermobile || "",
                    items: []
                };
            }

            groupedData[key].items.push(item);
        });

        const getReadyStatus = (value) => {
            if (value === "Y") return "Confirm";
            if (value === "N") return "Rejected";
            return "";
        };

        // ===== Loop groups =====
        Object.values(groupedData).forEach(group => {

            // ---- Customer Info ----
            currentY += 6;
            doc.setFontSize(6);
            doc.setFont(undefined, "bold");
            doc.text("Company Name:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(group.companyName, 40, currentY);
            currentY += 4;

            doc.setFont(undefined, "bold");
            doc.text("Customer Name:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(group.customerName, 40, currentY);
            currentY += 4;

            doc.setFont(undefined, "bold");
            doc.text("Mobile No:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(group.mobile, 40, currentY);
            currentY += 4;

            // ---- Calculate totals ----
            let totalQty = 0;
            let readyQty = 0;
            let rejectedQty = 0;

            group.items.forEach(item => {
                const qty = Number(item.Awak_Qty) || 0;
                totalQty += qty;

                if (item.Readyforsale === "Y") {
                    readyQty += qty;
                }

                if (
                    item.Readyforsale === "N" &&
                    item.RejectDate &&
                    item.AuctionMark === "N" &&
                    item.sold === "N" &&
                    Number(item.salebilldocno) === 0
                ) {
                    rejectedQty += qty;
                }
            });

            // ---- Table body ----
            const tableBody = group.items.map(item => [
                item.Doc_No,
                item.Doc_Date,
                item.ItemName,
                item.System_Name_E,
                item.LineName,
                getReadyStatus(item.Readyforsale),
                formatReadableAmount(item.oldsalerate),
                formatReadableAmount(item.Awak_Qty),
            ]);

            // ---- Draw table FIRST ----
            doc.autoTable({
                startY: currentY,
                head: [[
                    "Awak No",
                    "Date",
                    "Item Name",
                    "Godown Name",
                    "Line Name",
                    "Ready For Sale",
                    "Sale Rate",
                    "Quantity"
                ]],
                body: tableBody,
                styles: {
                    fontSize: 6,
                    cellPadding: 1,
                    halign: 'center',
                },
                headStyles: {
                    fillColor: [255, 0, 0],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                },
                columnStyles: {
                    0: { cellWidth: 15, halign: 'left' },
                    1: { cellWidth: 15 },
                    2: { cellWidth: 20 },
                    3: { cellWidth: 45 },
                    4: { cellWidth: 18 },
                    5: { cellWidth: 18 },
                    6: { cellWidth: 25, halign: 'right' },
                    7: { cellWidth: 25, halign: 'right' },
                }
            });

            currentY = doc.lastAutoTable.finalY + 3;

            doc.setFontSize(7);
            doc.setFont(undefined, "bold");

            const totalsLine =
                `Quantity Total : ${formatReadableAmount(totalQty || 0)}    ` +
                `Ready For Sale Qty : ${formatReadableAmount(readyQty || 0)}    ` +
                `Rejected Qty : ${formatReadableAmount(rejectedQty || 0)}`;

            doc.text(totalsLine, 15, currentY);

            currentY += 6;




            currentY = doc.lastAutoTable.finalY + 6;

        });

        // ===== GRAND TOTAL (ONLY ONCE AT END) =====
        currentY += 2;

        const grandTotalLine =
            `Total Quantity: ${formatReadableAmount(grandTotals.Awak_Qty)}              ` +
            `Ready For Sale Qty : ${formatReadableAmount(grandTotals.ReadyQty)}              ` +
            `Rejected Qty : ${formatReadableAmount(grandTotals.RejectedQty)}`;

        doc.autoTable({
            startY: currentY,
            theme: "grid",
            styles: {
                fontSize: 6,
                fontStyle: "bold",
                halign: "left"
            },
            body: [
                [
                    {
                        content: grandTotalLine,
                        colSpan: 8
                    }
                ]
            ],
            bodyStyles: {
                fillColor: [255, 255, 204],
                textColor: [0, 0, 0],
                cellPadding: { left: 2, right: 2, top: 1, bottom: 1 }
            }
        });

        const pdfBlob = doc.output('blob');
        setPdfPreview(URL.createObjectURL(pdfBlob));
        return pdfBlob;
    };





    const groupByAcCode = (data) => {
        const grouped = {};

        data.forEach(item => {
            const acKey = item.oldCustomerCode;
            const qty = Number(item.Awak_Qty) || 0;

            if (!grouped[acKey]) {
                grouped[acKey] = {
                    Customername: item.OLDCustomerName,
                    mobile: item.customermobile,
                    items: [],
                    totalQty: 0,
                    readyQty: 0,
                    rejectedQty: 0,
                };
            }

            grouped[acKey].items.push(item);
            grouped[acKey].totalQty += qty;


            if (item.Readyforsale === "Y") {
                grouped[acKey].readyQty += qty;
            }


            if (
                item.Readyforsale === "N" &&
                item.RejectDate &&
                item.AuctionMark === "N" &&
                item.sold === "N" &&
                Number(item.salebilldocno) === 0
            ) {
                grouped[acKey].rejectedQty += qty;
            }
        });

        return grouped;
    };




    const finalReportData = !oldCustomerCode
        ? reportData.filter(item => Number(item.oldCustomerCode) > 0)
        : reportData;


    const groupedData = groupByAcCode(finalReportData);



    const groupReportData = (data) => {
        const groupedData = {};
        data.forEach((item) => {
            const key = `${item.Id}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    items: [],
                    totalQty: 0,
                };
            }
            groupedData[key].items.push(item);
            // groupedData[key].totalQty += parseFloat(item.Bill_Amount) || 0;
        });
        return groupedData;
    };

    const groupedReportData = groupReportData(reportData);

    const safeAmount = (val) => {
        const num = Number(val);
        return isFinite(num) ? num : 0;
    };

    let emptyColsCount = oldCustomerCode ? 11 : 10;


    return (
        <div style={{ marginTop: "10px" }}>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Awak Customer Report</Typography>
            {oldCustomerCode && reportData.length > 0 && (
                <>
                    <Typography
                        variant="subtitle1"
                        style={{
                            textAlign: 'center',
                            fontSize: "16px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                        }}
                    >
                        Customer Name: {reportData[0]?.CustomerName || ""}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            textAlign: 'center',
                            fontSize: "14px",
                            marginBottom: "10px",
                            fontWeight: "normal",
                        }}
                    >
                        Mobile No: {reportData[0]?.customermobile || ""}
                    </Typography>
                </>
            )}

            {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{fromDate ? FormaDateBalanceSheet(fromDate) : ""} to {toDate ? FormaDateBalanceSheet(toDate) : ""}</Typography> */}

            <div className="mb-3 row align-items-center">
                <div className="col-auto">
                    <button className="btn btn-secondary me-2" onClick={handlePrint}>
                        Print
                    </button>
                    <button className="btn btn-success" onClick={handleExportToExcel}>
                        Export to Excel
                    </button>
                    <button className="btn btn-secondary me-2" onClick={() => generatePDFDocument(Company_Name,)}>
                        Preview PDF
                    </button>
                    {pdfPreview && (
                        <PdfPreview
                            pdfData={pdfPreview}
                            apiData={reportData[0]}
                            label={"SaleRegister"}
                        />
                    )}
                </div>
            </div>

            <div style={{
                maxHeight: 'calc(100vh - 200px)',
                overflow: 'auto',
                position: 'relative',
                border: '1px solid #e0e0e0',
                marginBottom: '60px'
            }} id="reportTable">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'white'
                    }}>
                        <TableRow>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Awak No</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Sauda Date</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Awak Date</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Quantity</TableCell>
                            {!oldCustomerCode && (
                                <>
                                    <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                                        Customer Code
                                    </TableCell>
                                    {/* <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                                        Customer Name
                                    </TableCell> */}
                                </>
                            )}
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Item Code</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Item Name</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Godown Code</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Godown Name</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Line Code</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Line Name</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Sale Rate</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Ready For Sale</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {/* List all items for this Ac_Code
                        {Array.isArray(reportData) && reportData.map((item, idx) => (
                            <TableRow
                                key={idx}
                                sx={{
                                    cursor: "pointer",
                                    "&:hover": { backgroundColor: "#fdfd96" },
                                }}
                            >

                                <TableCell>{item.Doc_No}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Doc_Date}</TableCell>
                                {!Customer_Code && (
                                    <>
                                        <TableCell style={{ textAlign: "center" }}>
                                            {item.Customer_Code}
                                        </TableCell>
                                        <TableCell style={{ textAlign: "center" }}>
                                            {item.CustomerName}
                                        </TableCell>
                                    </>
                                )}
                                <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Awak_Qty)}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Item_Code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.ItemName}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Godown_code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.System_Name_E}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Line_code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.LineName}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Readyforsale}</TableCell>
                            </TableRow>
                        ))} */}


                        {!oldCustomerCode && Object.entries(groupedData).map(([acCode, group], gIdx) => (
                            <React.Fragment key={gIdx}>


                                {/* Farmer Name Header */}
                                <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                                    <TableCell colSpan={3} style={{ textAlign: "left" }}>
                                        <span style={{ fontWeight: "bold" }}>
                                            Customer Name:
                                        </span>{" "}
                                        <span style={{ fontWeight: "normal", fontSize: "16px" }}>
                                            {group.Customername}   (Account Code: {acCode})
                                        </span>
                                        <span style={{ fontWeight: "normal", fontSize: "16px", marginLeft: "20px" }}>
                                            Mobile No: {group.mobile}
                                        </span>
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow>



                                {/* Farmer Rows */}
                                {group.items.map((item, idx) => (
                                    <TableRow key={idx} sx={{ "&:hover": { backgroundColor: "#fdfd96" } }}>
                                        <TableCell>{item.Doc_No}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{formatDate(item.SaudaDate)}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{item.Doc_Date}</TableCell>
                                        <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Awak_Qty)}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{item.oldCustomerCode}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{item.Item_Code}</TableCell>
                                        <TableCell style={{ textAlign: "left" }}>{item.ItemName}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{item.Godown_code}</TableCell>
                                        <TableCell style={{ textAlign: "left" }}>{item.System_Name_E}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{item.Line_code}</TableCell>
                                        <TableCell style={{ textAlign: "left" }}>{item.LineName}</TableCell>
                                        <TableCell style={{ textAlign: "left" }}>{formatReadableAmount(Number(item.oldsalerate ?? 0))}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{item.Readyforsale}</TableCell>
                                    </TableRow>
                                ))}

                                {/* Farmer Total */}
                                {/* <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={1} align="right">
                                        Quantity Total :
                                    </TableCell>

                                    <TableCell colSpan={2} align="right">
                                        {formatReadableAmount(group.totalQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow> */}

                                {/* Ready For Sale Qty */}
                                {/* <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={1} align="right">
                                        Ready For Sale Qty :
                                    </TableCell>

                                    <TableCell colSpan={2} align="right">
                                        {formatReadableAmount(group.readyQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow> */}

                                {/* Rejected Qty */}
                                {/* <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={1} align="right">
                                        Rejected Qty :
                                    </TableCell>

                                    <TableCell colSpan={2} align="right">
                                        {formatReadableAmount(group.rejectedQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow> */}
                                {/* Combined Total Row */}
                                <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={3} align="right">
                                        Quantity Total : {formatReadableAmount(group.totalQty)} &nbsp;&nbsp;&nbsp;
                                        Ready For Sale Qty : {formatReadableAmount(group.readyQty)} &nbsp;&nbsp;&nbsp;
                                        Rejected Qty : {formatReadableAmount(group.rejectedQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow>

                            </React.Fragment>
                        ))}


                        {/* WHEN Ac_code IS PASSED → NORMAL LIST */}
                        {oldCustomerCode && reportData.map((item, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{item.Doc_No}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{formatDate(item.SaudaDate)}</TableCell>
                                <TableCell align="center">{item.Doc_Date}</TableCell>
                                <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Awak_Qty)}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Item_Code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.ItemName}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Godown_code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.System_Name_E}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Line_code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.LineName}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{formatReadableAmount(item.oldsalerate ?? 0)}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Readyforsale}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow sx={{ backgroundColor: '#ffff99', fontWeight: 'bold' }}>
                            {/* Total label */}
                            <TableCell colSpan={1} style={{ textAlign: 'right' }}>
                                Total:
                            </TableCell>

                            {/* Awak Qty */}
                            <TableCell colSpan={2} style={{ textAlign: 'right' }}>
                                {formatReadableAmount(grandTotals.Awak_Qty)}
                            </TableCell>

                            {/* Remaining empty cells */}
                            {Array.from({
                                length: (oldCustomerCode ? 13 : 14) - 4
                            }).map((_, i) => (
                                <TableCell key={i} />
                            ))}
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#ffffcc', fontWeight: 'bold' }}>
                            <TableCell colSpan={1} style={{ textAlign: 'right' }}>
                                Ready For Sale Qty:
                            </TableCell>
                            <TableCell colSpan={2} style={{ textAlign: 'right' }}>
                                {formatReadableAmount(grandTotals.ReadyQty)} (Count: {grandTotals.ReadyCount})
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#ffffcc', fontWeight: 'bold' }}>
                            <TableCell colSpan={1} style={{ textAlign: 'right' }}>
                                Rejected Qty:
                            </TableCell>
                            <TableCell colSpan={2} style={{ textAlign: 'right' }}>
                                {formatReadableAmount(grandTotals.RejectedQty)} (Count: {grandTotals.RejectedCount})
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999
                }}>
                    <RingLoader size={80} />
                </div>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default AwakCustomerReport;
